// @ts-nocheck
import { Duty } from './models/Duty';
import { flow, getRoot, Instance, SnapshotIn, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { Page } from '../common/enums';
import { DutyAssignmentSearchCriteria } from './DutyAssignmentStore';
import { RootStore } from './RootStore';
import { DutyExchangeItemSearchCriteria } from './DutyExchangeItemStore';

export const DutyStore = types
  .compose(
    getBaseStore<Instance<typeof Duty>, SnapshotIn<typeof Duty>>(Duty, 'dutyId', 'duty'),
    types.model('DutyStore', {}),
  )
  .views((self) => ({
    getByIdOrNew(id: number) {
      if (id > 0) {
        return self.datas.get(id.toString());
      } else {
        return {
          dutyId: undefined,
        };
      }
    },
  }))
  .actions((self) => {
    const env = getEnvironment(self);
    const root: Instance<typeof RootStore> = getRoot(self);
    const apiFetcher = env.api;

    const saveDuty = flow(function*(duty: Instance<typeof Duty>) {
      const res = yield self.saveElement(duty);
      // @ts-ignore
      if (duty.dutyId !== res.dutyId) {
        root.ApplicationStore.navigate(
          // following URL must be replaced
          // @ts-ignore
          `${Page.Pharmacies}/${res.pharmacyId}`,
        );
      }
    });

    const loadPharmacyDuties = flow(function*(pharmacyId: number) {
      const res = yield env.api.get(`pharmacy/${pharmacyId}/duties`);
      // @ts-ignore
      self.putInStore(res);
      // @ts-ignore
      return res.map((elem: Instance<typeof Duty>) => elem.dutyId);
    });

    const searchForDutyAssignment = flow(function*(criteria: DutyAssignmentSearchCriteria) {
      const result = yield apiFetcher.get('dutyAssignment/duty', {
        params: criteria,
      });

      // @ts-ignore
      self.putInStore(result);
      // @ts-ignore
      const resultIds = result.map((r) => r.dutyId);
      return self.dataList.filter((d) => resultIds.indexOf(d.dutyId) >= 0);
    });

    const searchForDutyExchangeItem = flow(function*(criteria: Instance<typeof DutyExchangeItemSearchCriteria>) {
      const result = yield apiFetcher.get('dutyExchangeItem/duty', {
        params: criteria,
      });

      // @ts-ignore
      self.putInStore(result);
      // @ts-ignore
      const resultIds = result.map((r) => r.dutyId);
      return self.dataList.filter((d) => resultIds.indexOf(d.dutyId) >= 0);
    });

    return {
      searchForDutyAssignment,
      searchForDutyExchangeItem,
      saveDuty,
      loadPharmacyDuties,
    };
  });

export type DutyStoreType = Instance<typeof DutyStore>;
